import React from 'react';
import Formulario from './formulario';

export const FormularioAuxiliares = (props: any) => {
	let { handle, selected, onClose } = props;

	return <Formulario onSave={handle} selected={selected} onClose={onClose}/>
}

export default FormularioAuxiliares;